// The concrete section list. Split from settingsSections.ts so the ids and the
// deep-link parser stay import-free of React components (and therefore cheap to
// unit-test).
//
// Adding a section = one entry here. Order is Figma order.

import { CircleUser, MessageSquare, SlidersHorizontal, CreditCard, Users } from 'lucide-react'

import type { SettingsSectionDefinition } from './settingsSections'

export const SETTINGS_SECTIONS: SettingsSectionDefinition[] = [
  {
    id: 'profile',
    labelKey: 'settingsModal.nav.profile',
    Icon: CircleUser,
    isVisible: () => true,
  },
  {
    id: 'general',
    labelKey: 'settingsModal.nav.general',
    Icon: MessageSquare,
    isVisible: () => true,
  },
  {
    id: 'personalization',
    labelKey: 'settingsModal.nav.personalization',
    Icon: SlidersHorizontal,
    isVisible: () => true,
  },
  {
    id: 'teams',
    labelKey: 'settingsModal.nav.teams',
    Icon: Users,
    // One gate, and it lives HERE — the nav, the panel body and the deep-link
    // fallback all read this predicate, so they cannot disagree about whether
    // the section exists. With `teams_enabled` off the console renders no teams
    // UI anywhere and looks exactly as it does today.
    isVisible: (ctx) => ctx.teamsEnabled,
  },
  {
    id: 'usage-credits',
    labelKey: 'settingsModal.nav.usageAndCredits',
    Icon: CreditCard,
    // Two independent gates, both required: the @meta.com audience check and
    // the `billing_sandbox_enabled` flag. The gate lives HERE and nowhere else
    // — the nav, the panel and the deep-link fallback all read this one
    // predicate, so they cannot disagree about whether the section exists.
    isVisible: (ctx) => ctx.canSeeBilling && ctx.billingSandboxEnabled && ctx.canViewCredits,
  },
]
